module.exports = __webpack_public_path__ + "static/bilxtra_kortet-ff947b978175dca1f095faca37036c23.png";